<template>
  <div class="c-top-desk">
    <div class="wrapper">
<!--      <div class="left-side">-->
<!--        <div v-if="!!backroute" class="back-row-button" @click="$router.push({name: backroute})">-->
<!--          <div class="back-row">-->
<!--            <img :src="imgBackRow" alt="">-->
<!--          </div>-->
<!--        </div>-->
<!--        <div v-show="!onlyBackroute" class="input-place">-->
<!--          &lt;!&ndash; <div class="search-icon">-->
<!--            <img :src="imgSearch" alt="">-->
<!--          </div> &ndash;&gt;-->
<!--          &lt;!&ndash; <n-input class="top-desk-input" placeholder="Поиск" @input="handleSearchInput"/> &ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
      <div class="content-space">
        <div class="logo">
          <img :src="logo">
        </div>
        <div class="company">

          <n-loader :loading="$var('load')" />
          <div class="danger" v-html="$var('message')"></div>
          <!-- <div class="logo">
            <img :src="imgLogo" alt="">
          </div> -->
          <div class="title">
            {{ company.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgSearch from 'assets/search-icon.svg'
import imgNotify from 'assets/notify-icon.svg'
import imgBackRow from 'assets/back-row.svg'
import logo from '/src/assets/logo.png'

export default {
  name: 'CTopDesk',
  props: {
    searchFunction: Function,
    backroute: {
      type: String,
      default: null,
    },
    onlyBackroute: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // company: {},
      logo,
      imgSearch,
      imgNotify,
      imgBackRow,
    }
  },
  computed: {
    company() {
      return this.$store.state.app.company;
    },
  },
  watch: {},
  created() {
    // this.loadCompany()
  },
  methods: {
    loadCompany() {
      this.$var('load', true)
      $api.companies.get($app.auth.user().selectedCompany).then((response) => {
        this.company = response.data.content
      }).catch((response) => {
        this.$var('message', $app.secure.clean(response.response.data.message.replace(/\n/g, '<br>')))
      }).finally(() => {
        this.$var('load', false)
      })
    },
    handleSearchInput(text) {
      this.searchFunction(text)
    },
  },
}
</script>

<style lang="scss" scoped>
.c-top-desk {
  position: fixed;
  z-index: 10;
  left: 230px;
  right: 0;
  border-bottom: 0;
  top: 0;
  height: 80px;
  background-color: #F1F5F8;
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .left-side {
    padding: 3px;

    background-color: #F1F5F8;
    display: flex;
    align-items: center;
    .input-place {
      display: flex;
      align-items: center;
    }

    .search-icon {
      background-color: #FAFBFD;
      height: 40px;
      border-radius: 12px 0 0 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 25px;
      padding: 15px 0 17px 5px;
    }
    .top-desk-input {
      ::v-deep .n-content {
        background-color: #FAFBFD;
        padding-left: 5px;
        border: none;
        min-width: 490px;
        height: 40px;
        border-radius: 0 12px 12px 0;
      }
    }
    .back-row-button {
      cursor: pointer;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #FAFBFD;
      border-radius: 12px;
      margin-right: 10px;
      .back-row {
        width: 24px;
        height: 24px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
  .content-space {
    display: flex;
    justify-content: space-between;
    width: 100%;
    background-color: white;
    padding: 5px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dee4ee;

    .logo {
      height: 60px;

      img {
        max-width: 100%;
        height: 100%;
      }
    }
    .notify {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .company {
      // margin-left: 20px;
      display: flex;
      align-items: center;
      position: relative;
      min-width: 130px;
      .logo {
        width: 244px;
        height: 36px;
         img {
           width: 100%;
           height: 100%;
           object-fit: contain;
         }
      }
      .title {
        cursor: pointer;
        color: white;
        font-size: 1.1em;
        margin-left: 8px;
        border-radius: 11px;
        padding: 7px;
        border: 2px solid var(--primary);
        background-color: #035dcd;
      }
    }
  }

}
.danger {
  color: rgb(236, 90, 90);
}
</style>
